import { ActivityIndicator } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const UniActivityIndicator = withUnistyles(ActivityIndicator, (theme) => ({
  color: theme.colors.foregroundDefault,
}));

const Spinner = () => (
  <UniActivityIndicator
    size={CustomPlatform.select({
      default: "large",
      native: "small",
    })}
  />
);

export default Spinner;
